import React from "react";
import { useLocation } from "react-router-dom";
import {
  COACH_COMPONENT_TEMPLATES_LIBRARY_PUBLISHED_ROUTE,
  COACH_PROGRAMS_FOLDERS_ROUTE,
} from "../../../routes/routes";
import { ComponentType } from "@growth-machine-llc/stridist-api-client";
import { ComponentTemplateListFilterContext } from "../../../contexts/ComponentTemplateLibraryFilterContext";
import { CoachComponentTemplateLibraryHeaderFilters } from "../../../components/component-templates-library/CoachComponentTemplateLibraryHeaderFilters";
import { AllOption, AllOptionType } from "../../../constants";
import { CoachLibraryLayout } from "./CoachLibraryLayout";
import {
  useLibraryFiltersState,
  BaseLibraryFilters,
} from "../../../hooks/useLibraryFilterState";

export interface TemplateLibraryFilters extends BaseLibraryFilters {
  templateType: ComponentType[] | AllOptionType;
}

const CoachComponentTemplateLibraryWrapper = () => {
  const location = useLocation();

  const {
    query,
    sortKey,
    filters,
    page,
    rowsPerPage,
    privacy,
    handleQueryChange,
    handleSortKeyChange,
    updateFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleChangePrivacy,
    handleResetFilters,
    filtersToReset,
  } = useLibraryFiltersState<TemplateLibraryFilters>({
    defaultFilters: {
      templateType: AllOption,
    },
    resetOn: location.pathname,
  });
  const { templateType } = filters;

  const handleComponentTemplateTypeChange = React.useCallback(
    (type: ComponentType[] | AllOptionType) => {
      updateFilters({ templateType: type });
    },
    [updateFilters],
  );

  const filterContextValue = {
    query,
    sortKey,
    privacy,
    templateType,
    page,
    rowsPerPage,
    handleQueryChange,
    handleSortKeyChange,
    handleChangePrivacy,
    handleComponentTemplateTypeChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleResetFilters,
  };

  const showHeader = location.pathname !== COACH_PROGRAMS_FOLDERS_ROUTE;

  return (
    <CoachLibraryLayout
      Provider={ComponentTemplateListFilterContext.Provider}
      providerValue={filterContextValue}
      hideHeader={!showHeader}
      maxWidth="xl"
      header={
        showHeader ? (
          <CoachComponentTemplateLibraryHeaderFilters
            query={query}
            onChangeQuery={handleQueryChange}
            privacy={privacy}
            onChangePrivacy={handleChangePrivacy}
            sortKey={sortKey}
            onChangeSortKey={handleSortKeyChange}
            showResetButton={true}
            onResetFilters={handleResetFilters}
            disabledResetButton={!filtersToReset}
            showFilterByType={
              location.pathname ==
              COACH_COMPONENT_TEMPLATES_LIBRARY_PUBLISHED_ROUTE
            }
          />
        ) : undefined
      }
    />
  );
};

export default CoachComponentTemplateLibraryWrapper;
